export enum EColorMap {
  // Gray
  gray_0 = '#303037',
  gray_1 = '#ADB0B8',
  gray_2 = '#909090',
  gray_3 = '#8A8A8A',
  gray_4 = '#4B4B4B',
  // white
  white_0 = '#ffffff',
  // Transparent
  transparent = 'transparent',
}

interface IColorMap {
  [key: string]: string;
}

export const colorMap: IColorMap = {
  // Primary Blue
  blue_0: '#F3F9FF',
  blue_1: '#E6F2FF',
  blue_2: '#C5E1FF',
  blue_3: '#92C7FF',
  blue_4: '#5FACFF',
  blue_5: '#1184FF',
  blue_6: '#0C6CD3',
  blue_7: '#004C9E',
  blue_8: '#003267',

  // Gray
  white: '#fff',
  gray_0: '#F9F9FB',
  gray_1: '#EFEFF2',
  gray_2: '#EBEBEE',
  gray_3: '#E0E0E5',
  gray_4: '#CACACC',
  gray_5: '#B1B1B3',
  gray_6: '#767679',
  gray_7: '#444348',
  gray_8: '#15141A',
  blue_gray: '#8F8F9C',

  // System Color
  active_green: '#69DB7C',
  inactive_red: '#FF8787',
  warning_red_1: '#FFF0EE',
  warning_red_2: '#F8D0D1',

  // Green
  green: '#34C759',
  thumbs_green: '#40C057',
  text_green: '#00A21D',

  // Red
  red_5: '#FF6B6B',
  red_6: '#FA5252',
  red_7: '#F03E3E',
  red_8: '#E03131',
  red_9: '#C92A2A',
  red_10: '#A51111',

  // Orange
  orange_1: '#FFECE2',
  interview_orange_7: '#F38119',

  // Refferal Color
  referral_blue_1: '#E8EFF7',
  referral_blue_7: '#1864AB',
};
